module.exports = __webpack_public_path__ + "img/gate-rail-base-horizontal.738615c8.png";